import React from "react";
import PropTypes from "prop-types";
import RtrImage from "../shared/rtr-image";

class ReviewPhotoOnly extends React.Component {
  render() {
    let reviewImage;
    if (this.props.moment.coverPhoto) {
      reviewImage = (
        <a href={`/pdp/items/${this.props.moment.styleName}`}>
          <RtrImage src={this.props.moment.coverPhoto.urls.imageLargeThumb} alt="" />
        </a>
      );
    }

    return <div className="review-moment">{reviewImage}</div>;
  }
}

ReviewPhotoOnly.propTypes = {
  moment: PropTypes.shape({
    styleName: PropTypes.string.isRequired,
    coverPhoto: PropTypes.shape({
      urls: PropTypes.shape({
        imageLargeThumb: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default ReviewPhotoOnly;

export const { propTypes } = ReviewPhotoOnly;
